import { IExtsvcServerSettings } from '../types/IEditableServerSettings';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { TagRequest } from './TagRequest';

export type IGetExtsvcServerSettingsResult = IResult & IExtsvcServerSettings;

export class GetExtsvcServerSettingsRequest extends TagRequest<{}, IGetExtsvcServerSettingsResult> {
  constructor() {
    super('analyticsextensions', 'getAnalyticsExtensionsServerSettings', {});
  }
}
